/* connections.js */

"use strict";

const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const {
    Control: {
        Action: {Button},
        // Boolean: {InputCheckbox},
        // Textfield: {InputText},
        OptionSelection: {
            Single: {
                // InputRadio,
                ComboBox,
            },
        },
    },
} = uiCore;

class ConnectionsTab {
    constructor(ctx) {
        ctx._nbTenant = new ComboBox({
            darkTheme: true,
            required: false,
            disabled: true,
            options: [
                {
                    label: "None",
                    value: "",
                },
            ],
            value: "",
        });

        ctx._serviceConnectionSelection = new ComboBox({
            darkTheme: true,
            required: false,
            disabled: false,
            value: "",
            allowClear: true,
        });

        ctx._nbTestButton = new Button({
            label: "Test NetBox Connection",
            darkTheme: true,
            disabled: false,
        });

        ctx._addNewConnectionButton = new Button({
            label: "Add Connection",
            darkTheme: true,
            disabled: false,
            class: "add-connection-button",
        });

        ctx._noConnectionEl = document.createElement("div");
        ctx._noConnectionEl.classList.add("no-cmdb-connection");
        ctx._connectionsLinkEl = document.createElement("a");
        ctx._connectionsLinkEl.classList.add("connections-link", "hyperlink");
        ctx._connectionsLinkEl.innerHTML = "Connections View";
        ctx._noConnectionEl.innerHTML =
            "No NetBox connections available. Please create one in the&nbsp;";
        ctx._noConnectionEl.appendChild(ctx._connectionsLinkEl);
        const periodEl = document.createElement("span");
        periodEl.innerText = ".";
        ctx._noConnectionEl.appendChild(periodEl);

        ctx._handleConnectionsLinkClick = ctx._handleConnectionsLinkClick.bind(ctx);
    }

    /* RENDERER : START */

    _createConnectionsTabContent(ctx) {
        const _tabContentContainer = document.createElement("div");
        _tabContentContainer.classList.add("content-container");
        const _tabMainContent = document.createElement("div");
        _tabMainContent.classList.add("content-main", "hidden");
        const serviceConnectionSelectionContainer = ctx._uiUtils.wrapElement(
            ctx._serviceConnectionSelection.renderer.getRootElement(),
            "Connection",
            "input-container"
        );
        _tabMainContent.appendChild(serviceConnectionSelectionContainer);
        const tenantContainer = ctx._uiUtils.wrapElement(
            ctx._nbTenant.renderer.getRootElement(),
            "NetBox Tenant",
            "input-container"
        );
        tenantContainer.title = "NetBox Tenant";
        _tabMainContent.appendChild(tenantContainer);
        _tabMainContent.appendChild(ctx._addNewConnectionButton._renderer._rootElem);
        _tabMainContent.appendChild(ctx._nbTestButton._renderer._rootElem);

        _tabContentContainer.appendChild(_tabMainContent);
        _tabContentContainer.appendChild(ctx._noConnectionEl);
        ctx._nbConnectionsContent = _tabMainContent;
        return _tabContentContainer;
    }

    /* RENDERER : END */

    /* EVENT LISTENERS REGISTRATIONS : START */
    _registerConnectionTabEvents(ctx) {
        ctx._enableNetBox.on("UserValue", (ctx._enableChange = ctx._enableChange.bind(ctx)));
        ctx._nbTestButton.on(
            "UserClick",
            (ctx._testSSConnectivityAction = ctx._testSSConnectivityAction.bind(ctx))
        );

        ctx._nbTenant.on("UserValue", ctx._onNbTenantChange);
        ctx._serviceConnectionSelection.on("UserValue", ctx._onServiceConnectionChange);
        ctx._addNewConnectionButton.on(
            "UserClick",
            (ctx._newConnectionAction = ctx._newConnectionAction.bind(ctx))
        );
        ctx._connectionsLinkEl.addEventListener("click", ctx._handleConnectionsLinkClick);
    }

    _unregisterConnectionTabEvents(ctx) {
        ctx._enableNetBox.removeListener("UserValue", ctx._enableChange);
        ctx._nbTestButton.removeListener("UserClick", ctx._testSSConnectivityAction);
        ctx._nbTenant.removeListener("UserValue", ctx._onNbTenantChange);
        ctx._serviceConnectionSelection.removeListener("UserValue", ctx._onServiceConnectionChange);
        ctx._addNewConnectionButton.removeListener("UserClick", ctx._newConnectionAction);
        ctx._connectionsLinkEl.removeEventListener("click", ctx._handleConnectionsLinkClick);
    }

    /* EVENT LISTENERS REGISTRATIONS : END */

    /* HELPERS : START */
    _validateConnectionTab(ctx) {
        if (!ctx._model._nbDataSyncConfigEntity.getServiceConnectionId()) {
            return false;
        }
        return true;
    }

    _getConnectionId(ctx) {
        const serviceConnectionId = ctx._model._nbDataSyncConfigEntity.getServiceConnectionId();
        return serviceConnectionId;
    }

    _getConnectionOptions(ctx) {
        const connectionOptions = ctx._model._serviceConnectionEntities.map((entity) => {
            return {
                label: entity.name,
                value: entity.id,
            };
        });
        return connectionOptions;
    }

    _getNbTenantOpts(ctx) {
        const tenantMetaData = _.get(ctx._model, "_netBoxMetadata.tenants", []);
        const nbTenantOpts = [
            {
                label: "None",
                value: "",
            },
        ];
        if (tenantMetaData.length > 0) {
            tenantMetaData.forEach((tenant) => {
                nbTenantOpts.push({
                    label: tenant.display,
                    value: tenant.id,
                });
            });
        }
        return nbTenantOpts;
    }

    _getNbTenantValue(ctx) {
        const nbDataSyncMappings = ctx._model._nbDataSyncConfigEntity.getDataSyncMappings() || {};
        const nbTenantId =
            nbDataSyncMappings && nbDataSyncMappings.modelMapping
                ? nbDataSyncMappings.modelMapping.tenantId
                : "";
        return nbTenantId;
    }

    _getPristinePropertiesConnectionId(ctx) {
        const serviceConnectionId =
            ctx._model._nbDataSyncConfigEntity.pristineProperties.serviceConnectionId;
        return serviceConnectionId;
    }

    _setConnectionValue(ctx) {
        const serviceConnectionId = ctx._serviceConnectionSelection.getValue();
        ctx._model._nbDataSyncConfigEntity.setServiceConnectionId(serviceConnectionId);
    }

    _resetConnectionValue(ctx) {
        const serviceConnectionId = this._getPristinePropertiesConnectionId(ctx);
        ctx._serviceConnectionSelection.setValue(serviceConnectionId);
    }

    /* HELPERS : END */
}

module.exports = ConnectionsTab;
